export const table_titles = [
	{ name: "#", size: 3, order: "" },
	{ name: "Cliente", size: 10, order: "name_customer" },
	{ name: "Nombre", size: 10, order: "name" },
	{ name: "AnyDesk", size: 10, order: "anydesk_id" },
	{ name: "Campo", size: 10, order: "name_estate" },
	{ name: "Bodega", size: 10, order: "name_estate" },
	{ name: "Sinc.", size: 10, order: "last_sync" },
	{ name: "Estado", size: 10, order: "name_status" },
	{ name: "Versión", size: 5, order: "version" },
	{ name: "Acción", size: 8, order: "" },
];

export const base_balance = {
	balance_id: "",
	name: "",
	customer_id: "",
	estate_parent_id: "",
	estates: "",
	estates_parents: "",
	anydesk_id: "",
	location: "",
	status_id: "",
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};
